import { FC } from 'react'
import * as styles from 'components/features/pfm/SidebarPopup/SidebarPopupBackButton.styl'
import Icon from 'components/atoms/Icon'

type SidebarPopupBackButtonProps = {
  onClick: () => void
}
export const SidebarPopupBackButton: FC<SidebarPopupBackButtonProps> = (props) => {
  const { onClick } = props

  return (
    <div className={ styles.backButton } onClick={ onClick }>
      <Icon kind='chevron-secondary' />
    </div>
  )
}
